import React from 'react';
import { SiteContent, SiteMain } from '@vp/swan';
import _queryString from 'query-string';

// This is the default layout for the app. It is used by the _app.tsx file.
interface GenericLayoutProps {
    children: React.ReactNode;
    locale: string;
}

const GenericLayout: React.FC<GenericLayoutProps> = ({ children }) => {
    return (
        <SiteContent>
            <SiteMain>{children}</SiteMain>
        </SiteContent>
    );
};

export default GenericLayout;
